import React, { useState, useEffect} from "react";
import { useRedirection } from "../context/RedirectionContext";
import { Box, LinearProgress } from "@mui/material";
import Navbar from './Navbar/Navbar'
import NotificationBar from "./NotificationBar";
import VoiceSearch from "./FAB/VoiceSearch";
import AlertComponent from "./Alert";
const backgroundImage = require('../assets/background.svg').default;
const langaugeApi = require('../apis/languageApi');

// backgroundImage: `url(${backgroundImage})`

export default function Layout({ children }) {
	const [redirectionData, setRedirectionData] = useState();
	const [redirectingTo, setRedirectingTo] = useState();
	const [processing, setProcessing] = useState(false);

	const { setRedirection } = useRedirection();

	useEffect(() => {
		if (redirectionData) {
			switch (redirectionData.function_name) {
				case "view_inventory":
					setRedirection('/inventory', {filters: redirectionData.filters, itemCategory: redirectionData.item_category});
					setRedirectingTo('Inventory');
					break;
				case "show_transaction":
					setRedirection('/transactions', {duration: redirectionData.duration, itemCategory: redirectionData.item_category, filters: redirectionData.transaction_type});
					setRedirectingTo('Transactions');
					break
				case "generate_report":
					setRedirection('/report', {});
					setRedirectingTo('Report');
					break;
				case "add_transaction":
					setRedirection('/barcode', {itemList: redirectionData.item_list, transactionType: redirectionData.transaction_type});
					setRedirectingTo('Barcode');
					break;
				default:
					break;
			}
			setTimeout(() => {
				setRedirectingTo();
			}, 1500);
		}
	}, [redirectionData])

	return (
		<Box sx={{ position: "relative", display: 'flex', flexDirection: 'column', height: 'auto', minHeight: '100vh', backgroundColor: '#F1EFE7' }}>
			{processing && <LinearProgress sx={{ position: "absolute", width: "100%" }}/>}
			<header style={{ marginTop: '5px' }}>
				<Navbar />
			</header>
			<NotificationBar />
			<Box component='main' sx={{ flexGrow: 1, mt: 2}}>
				<Box sx={{ mr: 'auto', ml: 'auto', width: 'min(90vw, 1300px)' }}>
					{children}
				</Box>
			</Box>
			<Box sx={{ backgroundColor: '#FDFDFD', position: "sticky", marginLeft: "auto", bottom: "20px", right: "20px", borderRadius: "50%" }}>
				<VoiceSearch processing={processing} setProcessing={setProcessing} setData={setRedirectionData} />
				{/* <FloatingMic setData={setRedirectionData}/> */}
			</Box>
			{redirectingTo && <AlertComponent type='info' message={`Redirecting to ${redirectingTo} page.`} outlined={true}/>}
		</Box>
	)
}